/* Modulo: Video Social — scroll-snap clip rail + inline muted-in-view play. Vanilla, no deps. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__vsInit) return;
    var rail = root.querySelector('[data-vs-track]');
    if (!rail) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-vs-card]'));
    if (!cards.length) return;
    root.__vsInit = true;

    var prevBtn = root.querySelector('[data-vs-prev]');
    var nextBtn = root.querySelector('[data-vs-next]');
    var autoplay = root.getAttribute('data-vs-autoplay') === '1';

    function videoOf(card) { return card.querySelector('[data-vs-video]'); }

    /* ── arrows + bounds ── */
    function stepX() {
      var c = cards[0];
      var g = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || '20') || 20;
      return (c ? c.getBoundingClientRect().width : 240) + g;
    }
    var raf = 0;
    function sync() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (prevBtn) prevBtn.disabled = rail.scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = rail.scrollLeft >= max;
      });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { rail.scrollBy({ left: -stepX() * 2, behavior: REDUCE ? 'auto' : 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { rail.scrollBy({ left: stepX() * 2, behavior: REDUCE ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    /* ── playback ── */
    function pauseAll(except) {
      for (var i = 0; i < cards.length; i++) {
        if (cards[i] === except) continue;
        var v = videoOf(cards[i]);
        if (v && !v.paused) v.pause();
        cards[i].classList.remove('is-playing');
      }
    }
    function swapEmbed(card) {
      var emb = card.querySelector('[data-vs-embed]');
      if (!emb || emb.__done) return false;
      emb.__done = true;
      var f = document.createElement('iframe');
      f.src = emb.getAttribute('data-vs-embed');
      f.setAttribute('allow', 'autoplay; fullscreen; encrypted-media; picture-in-picture');
      f.setAttribute('allowfullscreen', 'true');
      f.setAttribute('title', 'Video');
      emb.appendChild(f);
      card.classList.add('is-playing');
      return true;
    }
    function updateMute(card) {
      var mb = card.querySelector('[data-vs-mute]');
      if (!mb) return;
      var unmuted = card.classList.contains('is-unmuted');
      mb.setAttribute('aria-label', unmuted ? 'Mute' : 'Unmute');
      mb.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
    }
    function playMuted(card) {
      var v = videoOf(card);
      if (!v) return;
      pauseAll(card);
      v.muted = true;
      card.classList.remove('is-unmuted');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      card.classList.add('is-playing');
      updateMute(card);
    }
    function playWithSound(card) {
      var v = videoOf(card);
      if (v) {
        pauseAll(card);
        v.muted = false;
        card.classList.add('is-unmuted');
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        card.classList.add('is-playing');
        updateMute(card);
      } else if (swapEmbed(card)) {
        pauseAll(card);
      }
    }
    function toggle(card) {
      var v = videoOf(card);
      if (v) {
        if (v.paused) playWithSound(card);
        else { v.pause(); card.classList.remove('is-playing'); }
      } else {
        swapEmbed(card);
      }
    }
    function toggleMute(card) {
      var v = videoOf(card); if (!v) return;
      v.muted = !v.muted;
      card.classList.toggle('is-unmuted', !v.muted);
      updateMute(card);
    }

    cards.forEach(function (card) {
      var media = card.querySelector('.modulo-vs__media');
      if (media) media.addEventListener('click', function () { toggle(card); });
      var mb = card.querySelector('[data-vs-mute]');
      if (mb) mb.addEventListener('click', function (e) { e.stopPropagation(); toggleMute(card); });
      var handle = card.querySelector('a.modulo-vs__handle');
      if (handle) handle.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    /* ── in-view muted autoplay: only the most-visible clip ── */
    if (autoplay && !REDUCE && 'IntersectionObserver' in window) {
      var ratios = {};
      cards.forEach(function (card, i) { card.__vsi = i; ratios[i] = 0; });
      var io = new IntersectionObserver(function (entries) {
        for (var k = 0; k < entries.length; k++) ratios[entries[k].target.__vsi] = entries[k].intersectionRatio;
        var best = null, bestR = 0;
        for (var i = 0; i < cards.length; i++) {
          var r = ratios[i] || 0;
          if (r > bestR) { bestR = r; best = cards[i]; }
        }
        if (best && bestR >= 0.6 && videoOf(best)) {
          if (!best.classList.contains('is-playing')) playMuted(best);
        } else {
          pauseAll(null);
        }
      }, { threshold: [0, 0.6, 0.9] });
      cards.forEach(function (card) { if (videoOf(card)) io.observe(card); });
    }

    /* ── staggered reveal ── */
    if (!REDUCE && 'IntersectionObserver' in window) {
      root.classList.add('is-ready');
      cards.forEach(function (card, i) { card.style.transitionDelay = (i * 55) + 'ms'; });
      var rio = new IntersectionObserver(function (es) {
        for (var k = 0; k < es.length; k++) {
          if (es[k].isIntersecting) { es[k].target.classList.add('is-in'); rio.unobserve(es[k].target); }
        }
      }, { threshold: 0.15 });
      cards.forEach(function (card) { rio.observe(card); });
    }

    sync();
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-vs]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
})();
